import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Juan P.', 'María L.', 'Carlos D.', 'Ana M.', 'Pedro S.', 'Lucía R.', 'Diego F.', 'Sofía B.', 'Andrés G.', 'Camila V.'];
const CITIES = ['Bogotá', 'Medellín', 'Santiago', 'Valparaíso', 'CDMX', 'Guadalajara', 'Monterrey', 'Cali', 'Lima', 'Quito'];
const PRODUCTS = ['Combo 1', 'Combo 2', 'Combo 3'];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    product: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const city = CITIES[Math.floor(Math.random() * CITIES.length)];
      const product = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
      setData({
        name,
        city,
        product
      });
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    };
    // Initial delay
    const timeout = setTimeout(() => {
      showPopup();
      // Loop
      const interval = setInterval(showPopup, Math.random() * 15000 + 15000); // 15-30 seconds
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(timeout);
  }, []);
  return <AnimatePresence data-id="element-136">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 z-50 bg-zinc-900 border border-green-500/30 p-4 rounded-lg shadow-2xl max-w-xs flex items-start gap-3" data-id="element-137">
          <div className="mt-1" data-id="element-138">
            <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-139" />
          </div>
          <div data-id="element-140">
            <p className="text-sm text-white font-medium" data-id="element-141">
              <span className="text-green-400 font-bold" data-id="element-142">{data.name}</span>{' '}
              <span className="text-zinc-500 text-xs" data-id="element-143">(compra verificada)</span>
            </p>
            <p className="text-xs text-zinc-400" data-id="element-144">de {data.city}</p>
            <p className="text-xs text-zinc-300 mt-1" data-id="element-145">
              acaba de comprar el{' '}
              <span className="font-bold text-white" data-id="element-146">{data.product}</span>
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}